import React from 'react';
import { Link } from 'react-router-dom';
import './SystemCertification.css';

const SystemCertification = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <h1 className="page-title">System Certification</h1>
            <div className="page-text-content">
              <p>
                System Certification is a comprehensive approach to ensuring that organizations meet 
                international standards for quality, safety, environmental protection, and operational 
                excellence. At NQC (Nova Quality Certification Agency), we provide a wide range of 
                system certification services to help businesses achieve their goals and demonstrate 
                their commitment to excellence.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is System Certification?</h2>
            <div className="page-text-content">
              <p>
                System Certification involves the assessment and verification of an organization's 
                management systems against internationally recognized standards. These certifications 
                demonstrate that an organization has implemented effective processes, procedures, and 
                controls to ensure consistent quality, safety, and compliance with regulatory 
                requirements.
              </p>
              <p>
                System certifications cover various aspects of business operations, including quality 
                management, environmental management, occupational health and safety, information 
                security, food safety, and many other specialized areas.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Benefits of System Certification</h2>
            <div className="benefits-list">
              <div className="benefit-item">
                <h3 className="benefit-title">1. Enhanced Credibility</h3>
                <p className="benefit-description">
                  System certification provides independent verification of your organization's 
                  commitment to quality and excellence, enhancing your credibility with customers, 
                  partners, and stakeholders.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">2. Improved Operational Efficiency</h3>
                <p className="benefit-description">
                  Certified management systems help streamline processes, reduce waste, and improve 
                  overall operational efficiency, leading to cost savings and better performance.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">3. Market Access</h3>
                <p className="benefit-description">
                  Many markets and customers require system certifications as a prerequisite for doing 
                  business. Certification opens doors to new opportunities and markets.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">4. Risk Management</h3>
                <p className="benefit-description">
                  System certifications help identify and manage risks effectively, protecting your 
                  organization from potential issues and ensuring business continuity.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">5. Competitive Advantage</h3>
                <p className="benefit-description">
                  Certification sets you apart from competitors and demonstrates your commitment to 
                  continuous improvement and customer satisfaction.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Our System Certification Services</h2>
            <div className="page-text-content">
              <p>
                NQC offers comprehensive system certification services covering a wide range of 
                international standards:
              </p>
            </div>
            <div className="services-grid">
              <div className="service-card">
                <h3 className="service-card-title">Quality Management</h3>
                <ul className="service-list">
                  <li><Link to="/iso-9001">ISO 9001 Quality Management System</Link></li>
                  <li><Link to="/iso-13485">ISO 13485 Medical Devices</Link></li>
                  <li><Link to="/iso-16949">ISO 16949 Automotive</Link></li>
                </ul>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">Environmental & Safety</h3>
                <ul className="service-list">
                  <li><Link to="/iso-14001">ISO 14001 Environmental Management</Link></li>
                  <li><Link to="/iso-45001">ISO 45001 Occupational Health & Safety</Link></li>
                  <li><Link to="/iso-50001">ISO 50001 Energy Management</Link></li>
                </ul>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">Food Safety</h3>
                <ul className="service-list">
                  <li><Link to="/iso-22000">ISO 22000 Food Safety Management</Link></li>
                </ul>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">Information Security</h3>
                <ul className="service-list">
                  <li><Link to="/iso-27001">ISO 27001 Information Security</Link></li>
                  <li><Link to="/iso-20000">ISO 20000 IT Service Management</Link></li>
                  <li><Link to="/iso-27701">ISO 27701 Privacy Management</Link></li>
                </ul>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">Business Continuity & Risk</h3>
                <ul className="service-list">
                  <li><Link to="/iso-22301">ISO 22301 Business Continuity</Link></li>
                  <li><Link to="/iso-31000">ISO 31000 Risk Management</Link></li>
                  <li><Link to="/iso-37001">ISO 37001 Anti-Bribery</Link></li>
                </ul>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">Specialized Standards</h3>
                <ul className="service-list">
                  <li><Link to="/iso-10002">ISO 10002 Customer Satisfaction</Link></li>
                  <li><Link to="/iso-28001">ISO 28001 Supply Chain Security</Link></li>
                  <li><Link to="/iso-22483">ISO 22483 Tourism Quality</Link></li>
                  <li><Link to="/iso-39001">ISO 39001 Road Traffic Safety</Link></li>
                </ul>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Certification Process</h2>
            <div className="process-list">
              <div className="process-item">
                <h3 className="process-title">1. Initial Assessment</h3>
                <p className="process-description">
                  We begin with a comprehensive assessment of your current systems and processes to 
                  identify gaps and areas for improvement.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">2. Gap Analysis</h3>
                <p className="process-description">
                  Our experts conduct a detailed gap analysis to determine what needs to be 
                  implemented or improved to meet certification requirements.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">3. Implementation Support</h3>
                <p className="process-description">
                  We provide guidance and support throughout the implementation process, helping you 
                  develop and document necessary procedures and controls.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">4. Certification Audit</h3>
                <p className="process-description">
                  Our qualified auditors conduct a thorough assessment to verify compliance with the 
                  standard requirements.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">5. Certification & Maintenance</h3>
                <p className="process-description">
                  Upon successful completion, you receive your certification. We provide ongoing 
                  support and surveillance audits to maintain your certification.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC?</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) is committed to providing exceptional 
                certification services with a focus on customer satisfaction and continuous improvement. 
                Our experienced team of auditors and consultants brings extensive knowledge and 
                expertise to help your organization achieve and maintain certification success.
              </p>
              <p>
                Contact us today to learn more about our system certification services and how we can 
                help your organization achieve its certification goals.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default SystemCertification;

